import { Typography } from "@components";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@shadcn-ui/button";
// import dayjs from "dayjs";
import Link from "next/link";
import React from "react";

const ChartFooter = () => {
  const LinkBtn = ({ href, text = "" }: { href: string; text?: string }) => {
    return (
      <Link href={href}>
        <Button size="sm" variant="ghost">
          <Typography.Muted className="flex items-center gap-1 text-xs">
            <span>{text}</span>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
          </Typography.Muted>
        </Button>
      </Link>
    );
  };
  return (
    <div className="text-center text-xs">
      {/* <div>提前规划，实现完美曲线</div> */}
      {/* <Typography.Muted>
        Copyright © {dayjs().year()} Record Inc. All rights reserved.
      </Typography.Muted> */}
      <div className="flex justify-center gap-2  ">
        <LinkBtn href="https://recordx.app/privacy" text="Privacy" />
        <LinkBtn href="https://recordx.app/privacy" text="Teams of Use" />
        <LinkBtn href="https://recordx.app/privacy" text="Legal" />
      </div>
    </div>
  );
};

export default ChartFooter;
